import { put } from '../Services/http';

let paymentAbortController = null;
const setPayment = (payload, useAbortController) => {
  if (useAbortController) {
    if (paymentAbortController) {
      paymentAbortController.abort();
    }
    paymentAbortController = new AbortController();
  }

  return put('api/checkout/setPaymentProvider', payload, paymentAbortController);
};

let deliveryAbortController = null;
const setDelivery = (payload, useAbortController) => {
  if (useAbortController) {
    if (deliveryAbortController) {
      deliveryAbortController.abort();
    }
    deliveryAbortController = new AbortController();
  }

  return put(
    'api/checkout/setDeliveryProvider',
    payload,
    deliveryAbortController
  );
};

let deliveryAndPaymentAbortController = null;
const setDeliveryAndPayment = (deliveryMethodId, paymentMethodId, useAbortController) => {
  if (useAbortController) {
    if (deliveryAndPaymentAbortController) {
      deliveryAndPaymentAbortController.abort();
    }
    deliveryAndPaymentAbortController = new AbortController();
  }

  return put(
    'api/checkout/setDeliveryAndPaymentProvider',
    { deliveryMethodId, paymentMethodId },
    deliveryAndPaymentAbortController
  );
};

export default {
  setPayment,
  setDelivery,
  setDeliveryAndPayment,
};
